import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

export const StatusCardLegacyContext = createContext<{
  showCollapsible: boolean
  setShowCollapsible: Dispatch<SetStateAction<boolean>>
}>({
  showCollapsible: false,
  setShowCollapsible: () => undefined,
})
